import { render, staticRenderFns } from "./requires.vue?vue&type=template&id=5c845158&scoped=true"
import script from "./requires.vue?vue&type=script&lang=js"
export * from "./requires.vue?vue&type=script&lang=js"
import style0 from "./requires.vue?vue&type=style&index=0&id=5c845158&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c845158",
  null
  
)

export default component.exports